import React from 'react';
import { Alert, Button, Typography } from '@mui/material';
import { useMedicalRecordsRetry } from '../hooks/useMedicalRecords';
import type { MedicalRecordsQueueItem } from '../data/medicalRecordsViews';

export const MedicalRecordsRetryAction: React.FC<{ item: MedicalRecordsQueueItem }> = ({ item }) => {
  const { submit, feedback, isLoading } = useMedicalRecordsRetry(item);
  if (item.status !== 'Failed') return null;
  if (item.isDemo) return null;
  if (!item.canRetry) return <Typography variant="caption">Retry unavailable; contact support to review the previous attempt.</Typography>;

  return <>
    <Button size="small" onClick={submit} disabled={isLoading || feedback === 'accepted'}>Retry</Button>
    {feedback === 'accepted' && <Alert severity="success">Retry queued.</Alert>}
    {feedback === 'error' && <Alert severity="error">Retry was not confirmed. Refresh My Requests before trying again.</Alert>}
  </>;
};
